import { Capacitor } from '@capacitor/core';

/**
 * True when running inside a Capacitor native shell (iOS/Android), false in the browser.
 * The auth transport uses this to choose between cookie-based (web) and bearer-token (native) auth.
 */
export const isNativePlatform = (): boolean => Capacitor.isNativePlatform();
